<footer class="footer text-center text-secondary" id="app-footer">
    <div class="container">
        <div class="col-12 text-center pt-5 pb-3 container-logos">
            <div *ngIf="showIconInc5000">
                <img loading="lazy" src="assets/images/funnels/Inc5000-logo.png" width="75" loading="lazy" priority="low">
            </div>
            <img loading="lazy" [src]="environment.assetsURL + 'img/logos/lets-encrypt.webp'" width="280" height="104"  class="footer-lets-encrypt" />
        </div>
        <div class="col-12 mb-3">
            <p>*The access to the Financial Insight Feed is an optional feature available for a ${{
                FunnelFlow.UpsellsProducts![currentUpsellProductIndex!]!.cycle1Price }} verification fee, followed by a {{
                FunnelFlow.UpsellsProducts![currentUpsellProductIndex!]!.cycle1BillDelay }} day introductory period. After the
                introductory period, you will be billed ${{ FunnelFlow.UpsellsProducts![currentUpsellProductIndex!]!.cycle2Price
                }} per month. Press Skip to opt-out.</p>
        </div>
        <hr class="border border-1" />
        <div class="row">
            <div class="col-md-5 text-start text-light">
            <p class="fw-bolder mb-2">© COPYRIGHT {{ currentYear }} {{ brandResources.companyTitle! }}. ALL RIGHTS RESERVED.</p>
            <p class="fw-bolder">{{ brandResources.companyTitle! }} is the proud owner of this website.</p>
            </div>
        </div>
    </div>
</footer>